jQuery('.file-request button').click(function(){
	
	var intent = jQuery( this ).attr( 'class' );
	var send = jQuery( '.consultant-banner' ).data( 'consultant' );
	var primary = jQuery( this ).parent().parent().data( 'consultant' );
	var student = jQuery( this ).parent().parent().data( 'student' );
	var request = jQuery( this ).parent().parent().data( 'id' );
	
	file_request( intent, send, primary, student, request );
	
	//parent - student ID, primary consultant ID
	//request-access
	
});

jQuery( 'body' ).on('click', '.student-result button', function(e){ 
	
	var intent = jQuery( this ).attr( 'class' );
	var send = jQuery( '.consultant-banner' ).data( 'consultant' );
	
	var primary = jQuery( this ).parent().parent().data( 'consultant' );
	var student = jQuery( this ).parent().parent().data( 'student' );
	
	//console.log(intent);
	console.log(primary);
	//console.log(send);
	//console.log(student);
	
	file_request( intent, send, primary, student, '' );
	
	//parent - student ID, primary consultant ID
	//request-access
	
});